export default __webpack_public_path__ + "static/bg-86ef231716b36b6800c64dd1acaba490.jpg";